import React from "react";
import { connect } from "react-redux";
import {
  reduxForm,
  formValueSelector,
  change,
  submit,
  SubmissionError,
  stopSubmit,
  destroy,
} from "redux-form";
import validate from "./validate";
import PickupFormComponent from "./form";
import {
  nextStep,
  setFormData,
  resetFormData,
  pickupBlocksApi,
} from "../pickup-form.actions";
import { getPickupBlockByType } from "utils/helpers";
import Tracking from "utils/tracking";
import { showToastError } from "../../../helpers";

/*
 *
 * Set Initial Values
 * Set any default values for this form here, they will be passed to redux form
 **/
let initialValues = {};

const thisForm = "publicPickupForm";

const mapStateToProps = (state, ownProps) => {
  const selectForm = formValueSelector(thisForm);
  const { pickupBlocks, dropOffLocations } = state.donorWizard;
  const { pickupTypes } = state.pickupTypes;
  const standardPickupType = pickupTypes.find(
    (pickupType) => pickupType.label === "Standard"
  );
  const furniturePickupType = pickupTypes.find(
    (pickupType) => pickupType.label === "Furniture"
  );

  const furniturePickupsAvailable =
    getPickupBlockByType(pickupBlocks, furniturePickupType).length > 0;
  const standardPickupsAvailable =
    getPickupBlockByType(pickupBlocks, standardPickupType).length > 0;

  const props = {
    pickupBlocks,
    dropOffLocations,
    addressSelected: state.donorWizard.formValues.mapAddress || null,
    hasFurniture: selectForm(state, "hasFurniture"),
    zipCode: state.donorWizard.formValues.zipCode || null,
    user: state.donorWizard.formValues.user || null,
    furniturePickupsAvailable,
    standardPickupsAvailable,
  };

  return { ...initialValues, ...ownProps.initialValues, ...props };
};

const mapDispatchToProps = (dispatch) => {
  const handleSubmit = (form) => (dispatch) =>
    new Promise((resolve, reject) => {
      // has Furniture Value is a string so it needs to be converted to boolean
      let hasFurniture = false;
      if (form.hasFurniture === "true") {
        hasFurniture = true;
      }

      dispatch(
        setFormData({ zipCode: form.zipCode, hasFurniture: hasFurniture })
      );

      resolve();
    });

  const handleSelect = (
    address,
    setNoPickupBlocks,
    setZipCodeFound,
    setDropOffFound
  ) => {
    if (!address || !address.place_id) {
      return false;
    }

    let getAddressComponent = (key) => {
      return address.address_components.find((component) => {
        let keyFound = component.types.find((tag) => {
          return tag === key;
        });

        return keyFound ? true : false;
      }).short_name;
    };

    let addressInfo = {
      zipCode: getAddressComponent("postal_code"),
      address: `${getAddressComponent("street_number")} ${getAddressComponent(
        "route"
      )}`,
      city: getAddressComponent("locality"),
      state: getAddressComponent("administrative_area_level_1"),
      mapAddress: address.formatted_address,
      lat: address.lat,
      lng: address.lng,
    };

    dispatch(setFormData(addressInfo));

    Tracking.track("Step 1: Logged: Address Searched", {
      zipCode: addressInfo.zipCode,
    });

    // Makes the actual API request who's promise is used for validation in redux-form
    dispatch(
      pickupBlocksApi.get({
        zipCode: addressInfo.zipCode,
        availableStops: true,
        futureEvents: true,
        enabled: true,
        dropOff: true,
        lat:
          typeof address?.geometry.location.lat === "function"
            ? address.geometry.location.lat()
            : address?.geometry.location.lat,
        lng:
          typeof address?.geometry.location.lng === "function"
            ? address.geometry.location.lng()
            : address?.geometry.location.lng,
      })
    )
      .then((q) => {
        let pickupBlocks = q.data;
        let zipCodeFound = q.zipCodeFound;
        let dropOff = q.dropOff;

        // Tracking.track("Step 1: Address Searched", {
        //   zipCode: addressInfo.zipCode,
        // });

        let hasPickupBlocks = pickupBlocks.length > 0;
        let hasDropOffs = dropOff.length > 0;

        if (zipCodeFound && !hasPickupBlocks) {
          setZipCodeFound(true);
          setNoPickupBlocks(true);
          // Tracking.track("Step 1: No Pickup Blocks Found, zip found");
        }

        if (zipCodeFound && hasPickupBlocks) {
          setZipCodeFound(true);
          setNoPickupBlocks(false);
          // Tracking.track("Step 1: Pickup Blocks Found");
        }

        if (!zipCodeFound && !hasPickupBlocks) {
          setZipCodeFound(false);
          setNoPickupBlocks(true);
          // Tracking.track("Step 1: No Pickup Blocks Found");
        }

        if (hasDropOffs) {
          setDropOffFound(dropOff);
        }

        dispatch(
          stopSubmit(thisForm, {
            warnings: { pickupBlocksAvailable: "true" },
          })
        );
      })
      .catch((err) => {
        dispatch(stopSubmit(thisForm, err.errors));
        showToastError();
      });

    dispatch(change(thisForm, "zipCode", addressInfo.zipCode));
  };

  const clearAutoCompleteResults = () => {
    dispatch(
      resetFormData([
        "zipCode",
        "address",
        "city",
        "state",
        "mapAddress",
        "pickupsAvailable",
        "pickupBlocks",
      ])
    );
    dispatch(destroy(thisForm));
    dispatch(pickupBlocksApi.reset());

    Tracking.track("Step 1: Public Address Search Cleared");

    // this.refs.nameInput.getDOMNode().focus()
  };

  return {
    handleSelect: handleSelect,
    onSubmit: (form) => dispatch(handleSubmit(form)),
    onClickAutoComplete: clearAutoCompleteResults,
    onSubmitSuccess: () => dispatch(nextStep()),
    requestLogin: () => dispatch(setFormData({ requestLogin: true })),
  };
};

// Create a component which injects redux form state, also handles handleSubmit of the underlying form component
const withForm = reduxForm({
  form: thisForm,
  destroyOnUnmount: false,
  validate,
})(PickupFormComponent);

// Connect to the store using a container component
const withConnect = connect(mapStateToProps, mapDispatchToProps)(withForm);

// Export Complete wrapper component ( Inject Reducer -> Connect -> Redux-Form -> Component )
export default withConnect;
